export const loadingData = (loading_state) => ({
  type: 'LOADING_DATA_BEGIN',
  payload: { loading: true, requests: loading_state.requests + 1 }
});

export const doneLoadingData = (loading_state) => ({
  type: 'LOADING_DATA_FINISH',
  payload: { loading: loading_state.requests === 1 ? false : true, requests: loading_state.requests - 1 }
});




// WEBPACK FOOTER //
// ./src/actions/loading.js